export const DATA_SOURCE_ITEM_LIMIT_SMALL: number = 250
export const DATA_SOURCE_ITEM_LIMIT_LARGE: number = 500
